export default __webpack_public_path__ + "static/media/portrait5.3336d3ac.png";